;var cphLightbox = cphLightbox || {};
(function($, window, document, undefined) {
    if(!$.isEmptyObject(cphLightbox)) return; // return out if 'cphLightbox' already defined

    var $body = $(document.body),
        $headCss = $('style#cph-lightbox-styles'),
        pluginName = 'cphLightbox',
        pluginInstance = 0,
        supportsHashChange = ('onhashchange' in window && (document.documentMode === undefined || document.documentMode > 7)),
        savedHashes = {};

    $(window).on('hashchange.' + pluginName, function() {
        var hash = window.location.hash.slice(1);
        if(hash && typeof savedHashes[hash] === 'object') {
            savedHashes[hash].element.cphLightbox(savedHashes[hash].options, savedHashes[hash].callback);
        }
    });

    function freezeBody() {
        if(!$body.data(pluginName + '-style')) {
            $body.data(pluginName + '-style', $body.attr('style'));
        }
        $body.css({overflow: 'hidden', minWidth: 0, width: $body.innerWidth() + 'px'});
    }

    function unfreezeBody() {
        var style = $body.data(pluginName + '-pre-style');
        $body.data(pluginName + '-style', '');
        if(style) $body.attr('style', style);
        else $body.removeAttr('style');
    }

    function makeTabbable(el) {
        var inner = el.find('.cph-lightbox_inner-wrap') || el.parent().find('.cph-lightbox_inner-wrap');
        if(inner.length) {
            var tabbable = inner.find('select, input, textarea, button, a, .cph-lightbox_button, [role="button"]').not('[tabindex="-1"]').filter(':visible'),
                firstTab = tabbable.first(),
                lastTab = tabbable.last();

            $(document.activeElement).blur();

            firstTab.add(lastTab).off('keydown');

            tabbable.not('.cph-lightbox_close').first().focus();

            lastTab.on('keydown', function(e) {
                if((e.which === 9 && !e.shiftKey)) {
                    e.preventDefault();
                    firstTab.focus();
                }
            });

            firstTab.on('keydown', function(e) {
                if((e.which === 9 && e.shiftKey)) {
                    e.preventDefault();
                    lastTab.focus();
                }
            });
        }
    }

    function setActiveModal() {
        var modals = $('.cph-lightbox');
        modals.removeClass('cph-lightbox_active');
        if(modals.length) {
            var activeModal = modals.first();
            activeModal.addClass('cph-lightbox_active');
            makeTabbable(activeModal);
            freezeBody();
        } else {
            unfreezeBody();
        }
    }

    function setImageWidth(img, srcset) {
        var sizes = srcset.match(/\s[0-9]+w/ig);
        if(sizes.length) {
            var largest = 0;
            $.each(sizes, function(i, v) {
                var size = parseInt(v);
                if(size && size > largest)
                    largest = size;
            });
        }
        //if(largest > 0) img.css({width : largest + 'px'});
        //if(largest > 0) img.css({maxWidth : largest + 'px'}); // this worked for gallery, but commenting above broke image
        return img;
    }

    function isContentJquery(content) {
        var $JQObj;

        if(content instanceof jQuery) {
            $JQObj = content;
        } else {
            var regex = new RegExp(/^(\#|\.)/);
            if(regex.test(content)) {
                $JQObj = $(content);
            }
        }

        if($JQObj instanceof jQuery) return $JQObj;
        return false;
    }

    function hex2rgb(hex, opacity) {
        var h = hex.replace('#', '');
        h = h.match(new RegExp('(.{' + h.length / 3 + '})', 'g'));
        for(var i = 0; i < h.length; i++)
            h[i] = parseInt(h[i].length === 1 ? h[i] + h[i] : h[i], 16);
        if(opacity) h.push(opacity);
        return 'rgba(' + h.join(',') + ')';
    }

    function lightenDarkenHex(hex, amt) {
        hex = hex.replace('#', '');
        var num = parseInt(hex, 16);
        var r = (num>>16) + amt;
        if(r > 255) r = 255; else if(r < 0) r = 0;
        var b = ((num>>8)&0x00FF) + amt;
        if(b > 255) b = 255; else if(b < 0) b = 0;
        var g = (num&0x0000FF) + amt;
        if(g > 255) g = 255; else if(g < 0) g = 0;
        return '#' + (g|(b<<8)|(r<<16)).toString(16);
    }

    var mixHex = function(color1, color2, weight) {
        function d2h(d) {
            return d.toString(16);
        }

        function h2d(h) {
            return parseInt(h, 16);
        }

        color1 = color1.replace('#', '');
        color2 = color2.replace('#', '');
        weight = (typeof (weight) !== 'undefined') ? weight : 50;
        var color = '#';
        for(var i = 0; i <= 5; i += 2) {
            var v1 = h2d(color1.substr(i, 2)),
                v2 = h2d(color2.substr(i, 2)),
                val = d2h(Math.floor(v2 + (v1 - v2) * (weight / 100.0)));
            while(val.length < 2) {
                val = '0' + val;
            }
            color += val;
        }
        return color;
    };

    function addHeadCss(override) {
        var headCssStyles = [], needsHeadCss;
        if(!$headCss.length) {
            needsHeadCss = true;
            $headCss = $('<style/>', {
                type: 'text/css',
                id  : 'cph-lightbox-styles'
            }).appendTo('head');
        }
        if(needsHeadCss || override) {
            headCssStyles.push('@-webkit-keyframes cph-lightbox-pulse{0%{transform:scale(0)}100%{transform:scale(1);opacity:0}}@keyframes cph-lightbox-pulse{0%{transform:scale(0)}100%{transform:scale(1);opacity:0}}.cph-lightbox_loader{position:relative;display:inline-block;width:1em;height:1em;margin:auto;background-color:transparent;font-size:7em;vertical-align:middle;overflow:hidden;z-index:1}.cph-lightbox_loader::before,.cph-lightbox_loader::after{-webkit-animation:cph-lightbox-pulse 1.5s infinite ease-out;animation:cph-lightbox-pulse 1.5s infinite ease-out;content:"";position:absolute;top:0;left:0;width:1em;height:1em;margin:0 auto;border-radius:100%;background-color:currentColor}.cph-lightbox_loader::after{-webkit-animation:cph-lightbox-pulse 1.5s infinite ease-out -350ms;animation:cph-lightbox-pulse 1.5s infinite ease-out -350ms}.cph-lightbox{transition:opacity 300ms ease-out;box-sizing:border-box;position:fixed;top:0;right:0;bottom:0;left:0;height:100%;width:100%;text-align:center;white-space:nowrap;z-index:1000;opacity:0}.cph-lightbox:before{display:inline-block;content:"";height:100%;vertical-align:middle}.cph-lightbox.cph-lightbox_visible{opacity:1}.cph-lightbox_type-iframe iframe{transform:translate3d(0, 0, 0);position:absolute;top:0;right:0;bottom:0;left:0;height:100%;width:100%;border:none}.cph-lightbox:not(.cph-lightbox_active) .cph-lightbox_close,.cph-lightbox:not(.cph-lightbox_active) .cph-lightbox_prev,.cph-lightbox:not(.cph-lightbox_active) .cph-lightbox_next,.cph-lightbox:not(.cph-lightbox_active) .cph-lightbox_misc{display:none !important}.cph-lightbox:not(.cph-lightbox_active) .cph-lightbox_shadow{box-shadow:none !important}.cph-lightbox_fx{transition:transform 300ms ease-out;transform:translateY(5%);position:absolute;top:0;right:0;bottom:0;left:0;text-align:center;white-space:nowrap;z-index:1000}.cph-lightbox_fx:before{display:inline-block;content:"";height:100%;vertical-align:middle}.cph-lightbox_fx.cph-lightbox_fx-show{transform:translateY(0)}.cph-lightbox_close,.cph-lightbox_prev,.cph-lightbox_next{font-family:Times, "Times New Roman", serif}.cph-lightbox_inner-wrap{box-sizing:border-box;-webkit-overflow-scrolling:touch;display:inline-block;position:relative;width:auto;height:auto;min-width:100%;max-width:100%;padding-top:0;text-align:left;vertical-align:top;overflow:visible;white-space:normal;cursor:default;z-index:1}.cph-lightbox_desktop.cph-lightbox_type-gallery .cph-lightbox_inner-wrap{vertical-align:middle}.cph-lightbox_inner-wrap>.cph-lightbox_close{position:absolute;bottom:-.6em;right:.1em;height:.5em;width:.75em;line-height:.5em;font-size:4rem;text-align:right;z-index:2;cursor:pointer;overflow:visible}.cph-lightbox_type-gallery .cph-lightbox_inner-wrap>.cph-lightbox_close{position:fixed;bottom:0;right:auto;left:50%;height:.685em;line-height:.685em;text-align:center;transform:translateX(-50%)}.cph-lightbox_desktop .cph-lightbox_inner-wrap{min-width:auto;max-width:90%;max-height:90%}.cph-lightbox_desktop .cph-lightbox_inner-wrap>.cph-lightbox_close{transition:opacity 350ms;top:-.6em;right:-.075em;bottom:auto;opacity:0.6}.cph-lightbox_desktop .cph-lightbox_inner-wrap>.cph-lightbox_close:hover{opacity:1}.cph-lightbox_type-gallery .cph-lightbox_inner-wrap{background:transparent}.cph-lightbox_desktop.cph-lightbox_type-gallery .cph-lightbox_inner-wrap>.cph-lightbox_close{position:absolute;bottom:auto;left:auto;top:-.6em;right:-.175em;height:.5em;line-height:.5em;transform:none}.cph-lightbox_type-gallery .cph-lightbox_prev,.cph-lightbox_type-gallery .cph-lightbox_next{position:fixed;bottom:0;left:0;height:.75em;line-height:.59em;width:.75em;text-align:center;font-size:4rem;z-index:2;cursor:pointer;overflow:visible}.cph-lightbox_type-gallery .cph-lightbox_next{left:auto;right:0}.cph-lightbox_type-gallery .cph-lightbox_misc{position:fixed;bottom:2.5em;left:0;width:100%;text-align:center;font-size:1rem;z-index:2}.cph-lightbox_type-gallery.cph-lightbox_desktop .cph-lightbox_prev,.cph-lightbox_type-gallery.cph-lightbox_desktop .cph-lightbox_next{transition:opacity 350ms;bottom:50%;width:5%;height:1em;line-height:.8em;font-size:8rem;transform:translateY(50%);opacity:0.6}.cph-lightbox_type-gallery.cph-lightbox_desktop .cph-lightbox_prev:hover,.cph-lightbox_type-gallery.cph-lightbox_desktop .cph-lightbox_next:hover{opacity:1}.cph-lightbox_type-gallery.cph-lightbox_desktop .cph-lightbox_misc{position:absolute;bottom:auto;left:0;top:-1.65em;width:auto;text-align:left;opacity:.8}.cph-lightbox_image,.cph-lightbox_gallery,.cph-lightbox_inner{position:relative;margin:0;padding:0;height:100%;width:100%;white-space:normal;text-align:left;overflow:hidden;cursor:default;z-index:1}.cph-lightbox_image .cph-lightbox_inner-padder,.cph-lightbox_gallery .cph-lightbox_inner-padder,.cph-lightbox_inner .cph-lightbox_inner-padder{padding-bottom:.01px}.cph-lightbox_image.cph-lightbox_inner-padded .cph-lightbox_inner-padder,.cph-lightbox_gallery.cph-lightbox_inner-padded .cph-lightbox_inner-padder,.cph-lightbox_inner.cph-lightbox_inner-padded .cph-lightbox_inner-padder{margin:1em}.cph-lightbox_image,.cph-lightbox_inner{-webkit-overflow-scrolling:touch;overflow:auto}.cph-lightbox_gallery-slide{text-align:center;transition:none !important}.cph-lightbox_gallery-slide>figure{display:inline-block;position:relative;margin:0;padding:0;overflow:hidden}.cph-lightbox_gallery-slide-inner{box-sizing:border-box;display:inline-block;overflow:auto;text-align:initial;vertical-align:bottom}.cph-lightbox_gallery-image{min-height:1px;min-width:1px;vertical-align:bottom}.cph-lightbox_gallery-caption{line-height:1.2em;margin:0;padding:0 .15em;font-size:.95em;text-align:initial;white-space:initial;overflow:auto}.cph-lightbox_gallery-caption>div{padding:.35em 0}.cph-lightbox_gallery-caption-under{box-sizing:content-box}.cph-lightbox_gallery-caption-within{position:absolute;right:0;bottom:0;left:0}.cph-lightbox_image{display:block;height:auto;width:auto;max-height:100%;max-width:100%;margin:auto}.cph-lightbox_title{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-o-text-overflow:ellipsis;box-sizing:border-box;display:block;width:100%;line-height:1.3em;margin:0;padding:.45em .45em .45em 1rem;font-size:1em}.cph-lightbox_title>.cph-lightbox_close{float:right;font-size:2.5em;color:inherit;cursor:pointer}.cph-lightbox_type-dialog .cph-lightbox_inner-wrap{max-height:100%;line-height:1.2;min-width:18em}.cph-lightbox_desktop .cph-lightbox_type-dialog .cph-lightbox_inner-wrap{max-width:42em}.cph-lightbox_buttons{box-sizing:border-box;padding:.225em .7em;border-top:1px solid;text-align:right}.cph-lightbox_button{transition:border-color 175ms, background-color 350ms;box-sizing:content-box;display:inline-block;height:2.3em;line-height:2.3em;margin:.225em;padding:0 .5em;border:1px solid transparent;background:transparent;font-size:87.5%;font-weight:bold;text-transform:uppercase;cursor:pointer}');
            headCssStyles.push('.cph-lightbox_loader { color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_shadow { box-shadow: 0 0 4px 0 ' + hex2rgb($.fn.cphLightbox.defaultColors.dark, .35) + '; }');
            headCssStyles.push('.cph-lightbox.cph-lightbox_active { background-color: ' + hex2rgb($.fn.cphLightbox.defaultColors.dark, .7) + '; }');
            headCssStyles.push('.cph-lightbox_type-gallery.cph-lightbox_active { background-color: ' + hex2rgb($.fn.cphLightbox.defaultColors.dark, .85) + '; }');
            headCssStyles.push('.cph-lightbox_inner-wrap { background-color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_inner-wrap > .cph-lightbox_close { color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_prev, .cph-lightbox_next, .cph-lightbox_misc { color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_image, .cph-lightbox_inner { background-color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_title { background-color: ' + $.fn.cphLightbox.defaultColors.accent + '; color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_buttons { border-color: ' + mixHex($.fn.cphLightbox.defaultColors.light, $.fn.cphLightbox.defaultColors.accent, 80) + '; }');
            headCssStyles.push('.cph-lightbox_button { color: ' + $.fn.cphLightbox.defaultColors.accent + '; }');
            headCssStyles.push('.cph-lightbox_button:active, .cph-lightbox_button:focus, .cph-lightbox_button:hover { border-color: ' + mixHex($.fn.cphLightbox.defaultColors.light, $.fn.cphLightbox.defaultColors.accent, 65) + '; background-color: ' + mixHex($.fn.cphLightbox.defaultColors.light, $.fn.cphLightbox.defaultColors.accent, 90) + '; }');
            headCssStyles.push('.cph-lightbox_gallery-caption { color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_gallery-caption-within { background-color: ' + hex2rgb($.fn.cphLightbox.defaultColors.dark, .60) + '; }');
            headCssStyles.push(':root { --swiper-theme-color: ' + $.fn.cphLightbox.defaultColors.light + '; }');
            headCssStyles.push('.cph-lightbox_gallery-caption-within { background-color: ' + hex2rgb($.fn.cphLightbox.defaultColors.dark, .60) + '; }');

            $.each($.fn.cphLightbox.defaultColors.elements, function(cls, colors) {
                headCssStyles.push('.cph-lightbox_button-' + cls + ' { border-color: ' + colors[0] + ' !important; color: ' + colors[0] + ' !important; }');
                headCssStyles.push('.cph-lightbox_button-' + cls + ':active, .cph-lightbox_button-' + cls + ':focus, .cph-lightbox_button-' + cls + ':hover { background-color: ' + mixHex($.fn.cphLightbox.defaultColors.light, colors[0], 20) + ' !important; color: ' + colors[1] + ' !important; }');
                headCssStyles.push('.cph-lightbox_bgcolor-' + cls + ' { border-color: ' + colors[0] + ' !important; background-color: ' + colors[0] + ' !important; color: ' + colors[1] + ' !important; }');
                headCssStyles.push('.cph-lightbox_bgcolor-hover-' + cls + ':active, .cph-lightbox_bgcolor-hover-' + cls + ':focus, .cph-lightbox_bgcolor-hover-' + cls + ':hover { background-color: ' + mixHex(colors[1], colors[0], colors[2]) + ' !important; }');
            });

            $headCss.text(headCssStyles.join(' '));
        }
    }

    function Plugin(element, options, callback) {
        var altOptions = {};
        this.element = element;
        this._name = pluginName;
        this._instance = pluginInstance++;
        this._contentElements = [];
        this._defaults = $.fn.cphLightbox.defaults;
        if(typeof options.type !== 'undefined') {
            if(options.type === 'gallery') {
                altOptions.closeOnEscape = null;
                altOptions.closeOnClickOutside = null;
            }
            if(options.type === 'iframe') {
                altOptions.width = '75em';
                altOptions.height = '31.25em';
            }
        }
        options = $.extend(true, {}, altOptions, options);
        this.options = $.extend(true, {}, this._defaults, options);
        this.callback = callback;
        this.init();
    }

    $.extend(Plugin.prototype, {
        init: function() {
            var plugin = this;
            addHeadCss();

            if(this.options.confirm) {
                var thisOptions = this.options,
                    confirmOptions = {},
                    confirmMessage;

                if(typeof this.options.confirm === 'object') {
                    confirmOptions = this.options.confirm;
                } else {
                    confirmOptions.content = this.options.confirm;
                }

                confirmMessage = confirmOptions.content.split('\n');
                confirmMessage = '<p>' + confirmMessage.join('<\/p> <p>') + '<\/p>';
                confirmOptions.content = confirmMessage;

                var doYes = function() {
                    thisOptions.confirm = null;
                    $(this).cphLightbox(thisOptions);
                };

                return $(this.element).cphConfirm(null, doYes, null, confirmOptions);
            }

            /**
             * keep this after 'confirm' block so a lightbox does not get created for referring click.
             * if moved above, a new, empty lightbox will eb injected into DOM
             */
            this.buildCache();
            this.bindEvents();

            this._doCallback(this.options.onInit);

            setActiveModal();
            this._setOuterZ();

            this.$modal.addClass('cph-lightbox_visible');

            if(this.options.type === 'image' && this.options.image.src) {

                this._showImage();

            } else if(this.options.type === 'gallery' && (this.options.gallery.slides || this.options.gallery.selector)) {

                this._showGallery();

            } else if(this.options.type === 'iframe' && this.options.iframe.src) {

                this._showIframe();

            } else if(this.options.type === 'ajax' && this.options.ajax.url) {

                this._showAjax();

            } else if(this.options.type === 'dialog' && this.options.content) {

                this._showDialog();

            } else {

                this._showInline();

            }

            // LEAVE AT END OF INIT BLOCK
            setTimeout(function() {
                plugin._doCallback(plugin.callback);
            }, this.options.transitionTime + 10);
        },

        destroy: function() {
            var plugin = this;
            /*
                We can call methods directly on the instance outside of the
                plugin initalization, ie:
                $('selector').data('plugin_cphLightbox').someOtherFunction();

                Consequently, the destroy method can be called using:
                $('selector').data('plugin_cphLightbox').destroy();
            */
            this.unbindEvents();
            this.$element.removeData();

            this._doCallback(plugin.options.onBeforeClose);

            this.$modal.removeClass('cph-lightbox_visible');
            this.$fx.removeClass('cph-lightbox_fx-show');

            setTimeout(function() {
                plugin.$modal.remove();
                plugin._replaceInnerContent();
                plugin._doCallback(plugin.options.onClose);
                setActiveModal();
            }, this.options.transitionTime + 10);
        },

        buildCache: function() {
            this.$element = $(this.element);

            this.$loader = $('<div/>', {class: 'cph-lightbox_loader'});

            this.$modal = $('<div/>', {
                class: 'cph-lightbox cph-lightbox_type-' + this.options.type,
                html : this.$loader
            }).css({transitionDuration: this.options.transitionTime + 'ms'}).data('transition-time', this.options.transitionTime);

            this.$fx = $('<div/>', {class: 'cph-lightbox_fx'}).css({transitionDuration: this.options.transitionTime + 'ms'});

            this.$innerWrap = $('<div/>', {class: 'cph-lightbox_inner-wrap'});

            this.$inner = $('<div/>', {class: 'cph-lightbox_inner'});

            this.$innerPad = $('<div/>', {class: 'cph-lightbox_inner-padder'});

            this.$modal.prependTo('body');

            this.$close = $('<span/>', {class: 'cph-lightbox_close', text: '×', role: 'button', tabindex: '0'});

            this.$prev = $('<span/>', {class: 'cph-lightbox_prev', text: '‹'});

            this.$next = $('<span/>', {class: 'cph-lightbox_next', text: '›'});

            this.$misc = $('<span/>', {class: 'cph-lightbox_misc'});

            this.$title = $('<h5/>', {class: 'cph-lightbox_title'});

            if(this.options.showClose) this.$innerWrap.html(this.$close);
            if(this.options.type !== 'gallery') this.$innerWrap.addClass('cph-lightbox_shadow');
            if(this.options.type === 'gallery') this.$innerWrap.append([this.$prev, this.$next, this.$misc]);
            if(this.options.innerClass) this.$inner.addClass(this.options.innerClass);
            if(this.options.outerClass) this.$modal.addClass(this.options.outerClass);
            if(this.options.closeOnClickOutside) this.$modal.css({cursor: 'pointer'});
        },

        bindEvents: function() {
            var plugin = this;
            if(supportsHashChange && plugin.options.hash) {
                /**
                 * Set hash if available. Store info about opened lightbox / element.
                 * Destroy if hash changes and does not match current hash. Open logic
                 * is in global 'hashchange' handler at top of plugin.
                 */
                window.location.hash = plugin.options.hash;

                savedHashes[plugin.options.hash] = {
                    element : plugin.$element,
                    options : plugin.options,
                    callback: plugin.callback
                };

                setTimeout(function() {
                    $(window).on('hashchange.' + plugin._name + plugin._instance, function() {
                        if(window.location.hash.slice(1) !== plugin.options.hash) {
                            plugin.destroy();
                        }
                    });
                }, 200);
            }

            plugin.$modal.on('close.' + plugin._name, function() {
                plugin._closeLightbox();
            });

            plugin.$close.on('keypress', function(e) {
                if(e.keyCode === 13) {
                    $(this).trigger(plugin.options.clickEvent);
                }
            });

            plugin.$close.one(plugin.options.clickEvent + '.' + plugin._name, function(e) {
                e.stopPropagation();
                plugin._closeLightbox();
            });

            if(plugin.options.closeOn) {
                $(document).on(plugin.options.clickEvent + '.' + plugin._name + plugin._instance, plugin.options.closeOn, function(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    plugin._closeLightbox();
                });
            }

            if(plugin.options.closeOnEscape) {
                $(document).on('keyup.' + plugin._name + plugin._instance, function(e) {
                    if(e.keyCode === 27) {
                        e.stopPropagation();
                        plugin._closeLightbox();
                    }
                });
            }

            if(plugin.options.closeOnClickOutside) {
                plugin.$modal.on(plugin.options.clickEvent + '.' + plugin._name, function(e) {
                    var close = true;
                    if($(e.target).hasClass('cph-lightbox_inner')) {
                        close = false;
                    } else if($(e.target).closest('.cph-lightbox_inner').length) {
                        close = false;
                    } else if($(e.target).hasClass('cph-lightbox_image')) {
                        close = false;
                    } else if($(e.target).hasClass('cph-lightbox_gallery')) {
                        close = false;
                    } else if($(e.target).closest('.cph-lightbox_gallery').length) {
                        close = false;
                    } else if($(e.target).hasClass('cph-lightbox_title')) {
                        close = false;
                    }

                    if(close) {
                        e.stopPropagation();
                        plugin._closeLightbox();
                    }
                });
            }
        },

        unbindEvents: function() {
            $(window).off('.' + this._name + this._instance);
            $(document).off('.' + this._name + this._instance);
            this.$element.off('.' + this._name);
            this.$modal.off('.' + this._name);
            this.$close.off('.' + this._name);
        },

        _doCallback: function(callback) {
            if(typeof callback === 'function') {
                callback.call(this.element);
            } else if(typeof callback === 'string') {
                $.each(callback.split(/,|\||\;/), function(i, v) { // will split string on comma, pipe or semicolon
                    if(typeof window[v] === 'function') {
                        window[v].call(this.element);
                    }
                });
            }
        },

        _setOuterZ: function() {
            var zIndex = parseInt(this.$modal.css('zIndex'));
            if(this.options.zIndex) {
                zIndex = parseInt(this.options.zIndex);
                this.$modal.add(this.$fx).css({zIndex: zIndex});
            }
            $('.cph-lightbox').each(function() {
                var thisZ = parseInt($(this).css('zIndex'));
                if(thisZ > zIndex) {
                    zIndex = thisZ;
                }
            });
            this.$modal.css({zIndex: zIndex + 1});
        },

        _setScreenSizeClass: function(callback) {
            var plugin = this,
                wHeight = $(window).height(),
                wWidth = $(window).width(),
                isDesktop = false,
                topPad = 0,
                bottomPad = 60,
                wrapMax;

            if(wWidth < this.options.breakpoint) {
                this.$modal.removeClass('cph-lightbox_desktop');
            } else {
                this.$modal.addClass('cph-lightbox_desktop');

                isDesktop = true;
                if(this.options.type === 'gallery') {
                    topPad = 30;
                    bottomPad = 60;
                } else {
                    topPad = 60;
                    bottomPad = 30;
                }
            }

            wrapMax = parseInt(wHeight - topPad - bottomPad);

            this.$modal.add(this.$fx).css({padding: '0'});
            this.$innerWrap.css({maxHeight: wrapMax + 'px'}).data('max-height', wrapMax);
            this.$inner.css({maxHeight: 'none'});

            if(this.options.ratio && (this.options.height || this.options.width)) {
                var ratioParts = this.options.ratio.split(':'),
                    ratio = (ratioParts[1] / ratioParts[0]),
                    ratioHeight = this.$innerWrap.outerWidth() * ratio;

                if(ratioHeight < wrapMax) {
                    this.$innerWrap.css({height: Math.floor(ratioHeight) + 'px'});
                } else {
                    this.$innerWrap.css({height: Math.floor(wrapMax) + 'px'});
                    this.$innerWrap.css({width: Math.floor(wrapMax / ratio) + 'px'});
                }
            }

            var mHeight = parseInt(this.$innerWrap.outerHeight());

            var hDiff = wHeight - mHeight,
                tHeight = this.$title ? parseInt(this.$title.outerHeight()) : 0,
                innerMax;

            if(isDesktop && this.options.type !== 'gallery') { // too jumpy for galleries
                if(hDiff > topPad) {
                    var newPad = parseInt(hDiff / 3);
                    if(tHeight || newPad > topPad)
                        topPad = newPad;
                }

                if(this.options.type === 'dialog') {
                    this.$fx.css({padding: '1em'});
                }
            }

            wrapMax = parseInt(wHeight - topPad - bottomPad);
            innerMax = parseInt(wrapMax - tHeight);

            this.$fx.css({paddingTop: topPad + 'px'});
            this.$innerWrap.css({maxHeight: wrapMax + 'px'}).data('max-height', wrapMax);
            this.$inner.css({maxHeight: innerMax + 'px'});

            this.$innerWrap.trigger('cphGalleryMaxHeight');

            this.$fx.addClass('cph-lightbox_fx-show');

            setTimeout(function() {
                plugin._doCallback(callback);
            }, this.options.transitionTime + 1);
        },

        _addInnerContent: function() {
            var plugin = this,
                $JQObj = isContentJquery(plugin.options.content);

            if($JQObj) {
                plugin.options.content = [];
                $JQObj.each(function(i) {
                    var $el = $(this);
                    plugin.options.content.push($el.children().detach());
                    plugin._contentElements.push($el);
                });
            }

            plugin.$innerPad.html(plugin.options.content).appendTo(plugin.$inner);
        },

        _replaceInnerContent: function() {
            var plugin = this;
            $.each(plugin._contentElements, function(i) {
                $(this).html(plugin.options.content[i]);
            });
        },

        _showModalInner: function(callback) {
            var plugin = this;
            var resizeTimer;

            if(this.options.height)
                this.$innerWrap.css({height: this.options.height});

            if(this.options.width)
                this.$innerWrap.css({width: this.options.width});

            this.$innerWrap.append(this.$inner);

            this.$fx.html(this.$innerWrap).appendTo(this.$modal);

            if(this.options.title && this.options.title !== true) {
                if(this.options.titleClass) {
                    $.each(this.options.titleClass.split(' '), function(i, titleClass) {
                        if(Object.keys($.fn.cphLightbox.defaultColors.elements).indexOf(titleClass) !== -1) {
                            plugin.$title.addClass('cph-lightbox_bgcolor-' + titleClass);
                        } else {
                            plugin.$title.addClass(titleClass);
                        }
                    });
                }
                if(this.options.titleCss) {
                    plugin.$title.attr('style', this.options.titleCss);
                }
                if(this.options.showClose) this.$title.html(this.$close);
                this.$title.append(this.options.title);
                this.$innerWrap.prepend(this.$title);
            }

            this._doCallback(plugin.options.onBeforeOpen);

            this.$loader.remove();
            this._setScreenSizeClass(function() {
                plugin._doCallback(plugin.options.onOpen);
                setTimeout(function() {
                    plugin._doCallback(callback);
                }, 0);
                setTimeout(function() {
                    makeTabbable(plugin.$modal);
                }, 10);
            });

            $(window).on('resize.' + this._name + this._instance, function() {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function() {
                    unfreezeBody();
                    plugin._setScreenSizeClass();
                    freezeBody();
                }, 200);
            });
        },

        _showInline: function() {
            if(!this.options.content) {
                this.destroy();
                this.$element.cphAlert('ERROR: The "content" parameter needs to be defined', null, {titleClass: 'alert'});
            } else {
                this._addInnerContent();
                if(this.options.padded) this.$inner.addClass('cph-lightbox_inner-padded');
                this._showModalInner();
            }
        },

        _showImage: function() {
            var plugin = this;

            this.$image = $('<img/>').on('load', function() {
                plugin.$inner = $(this).addClass('cph-lightbox_image');
                plugin._showModalInner();
            }).on('error', function() {
                plugin.destroy();
                plugin.$element.cphAlert('Image unavailable', null, {titleClass: 'alert'});
            }).attr('src', this.options.image.src);

            if(this.options.image.srcset) {
                this.$image.attr('srcset', this.options.image.srcset);
                this.$image = setImageWidth(this.$image, this.options.image.srcset);
            }

            if(this.options.image.sizes)
                this.$image.attr('sizes', this.options.image.sizes);
        },

        _showGallery: function() {
            var plugin = this;

            if(plugin.options.gallery.selector) {
                plugin.options.gallery.slides = [];

                var $JQObj = isContentJquery(plugin.options.gallery.selector);
                if($JQObj) {
                    $JQObj.each(function() {
                        var parseItem = function(item) {
                            var image, html, caption;
                            if(item.is('img')) {
                                image = item;
                                caption = image.attr('title');
                            } else if(item.is('figure')) {
                                image = item.find('img').first();
                                caption = item.find('figcaption').first().html();
                                if(image.length && !caption) caption = image.attr('title');
                                if(!image.length) {
                                    $(item).find('figcaption').remove();
                                    html = item.html();
                                }
                            } else {
                                html = item.html();
                                caption = null;
                            }
                            if(image && image.length) {
                                plugin.options.gallery.slides.push({
                                    src    : image.attr('src') || image.attr('data-src'),
                                    srcset : image.attr('srcset') || image.attr('data-srcset'),
                                    sizes  : image.attr('sizes') || image.attr('data-sizes'),
                                    alt    : image.attr('alt'),
                                    caption: caption
                                });
                            } else if(html) {
                                plugin.options.gallery.slides.push({
                                    content: html,
                                    caption: caption
                                });
                            }
                        };

                        if($(this).is('img, figure')) {
                            parseItem($(this));
                        } else if($(this).find('>img, >figure').length) {
                            $(this).find('>img, >figure').each(function() {
                                parseItem($(this));
                            });
                        } else {
                            $(this).each(function() {
                                parseItem($(this));
                            });
                        }
                    });
                }
            }
            if($.isArray(plugin.options.gallery.slides) && plugin.options.gallery.slides.length) {
                var slides = [], slideNum = 0;
                $.each(plugin.options.gallery.slides, function(i, slide) {
                    var slideObj = {};

                    if(typeof slide.content !== 'undefined') {
                        var slideContent = [];
                        var $JQObj = isContentJquery(slide.content);

                        if($JQObj) {
                            plugin.options.content = [];
                            $JQObj.each(function(i) {
                                var $el = $(this);
                                plugin.options.content.push($el.children().detach());
                                plugin._contentElements.push($el);
                                slideContent.push(plugin.options.content[i]);
                            });
                        } else {
                            slideContent.push(slide.content);
                        }

                        if(slideContent.length) {
                            slideObj.type = 'html';
                            slideObj.content = slideContent;
                            slideObj.class = [];
                            slideObj.css = ['background-color: ' + $.fn.cphLightbox.defaultColors.light];
                        }

                    } else {

                        if(slide && typeof slide === 'string') {
                            var src = slide;
                            slide = {};
                            slide.src = src;
                        }

                        if(slide.src) {
                            var img = [], imageAtts = {};
                            if(plugin.options.gallery.lazyload) {
                                imageAtts['data-src'] = slide.src;
                                if(slide.srcset) imageAtts['data-srcset'] = slide.srcset;
                                if(slide.sizes) imageAtts.sizes = slide.sizes;
                                if(slide.alt) imageAtts.alt = slide.alt;
                                imageAtts.class = 'swiper-lazy cph-lightbox_gallery-image';

                                img.push($('<img/>', imageAtts));
                                img.push($('<div class="swiper-lazy-preloader"/>'));
                            } else {
                                imageAtts.src = slide.src;
                                if(slide.srcset) imageAtts.srcset = slide.srcset;
                                if(slide.sizes) imageAtts.sizes = slide.sizes;
                                if(slide.alt) imageAtts.alt = slide.alt;
                                imageAtts.class = 'cph-lightbox_gallery-image';

                                img.push($('<img/>', imageAtts));
                            }

                            slideObj.type = 'image';
                            slideObj.content = img;
                            slideObj.class = [];
                            slideObj.css = [];
                        }
                    }

                    if(!$.isEmptyObject(slideObj)) {
                        slideObj.class.push('cph-lightbox_gallery-slide-inner');

                        if(plugin.options.gallery.slideClass)
                            slideObj.class.push(plugin.options.gallery.slideClass);

                        if(plugin.options.gallery.slideCss)
                            slideObj.css.push(plugin.options.gallery.slideCss);

                        var slideFigure = $('<figure/>', {
                            html: $('<div/>', {
                                class: slideObj.class.join(' '),
                                style: slideObj.css.join('; '),
                                html : slideObj.content
                            })
                        }).data('slide-num', ++slideNum);

                        if(typeof slide.onShow === 'function') {
                            slideFigure.data('onShow', slide.onShow);
                        }

                        if(typeof slide.onHide === 'function') {
                            slideFigure.data('onHide', slide.onHide);
                        }

                        if(plugin.options.gallery.captions && slide.caption) {
                            var captionType = slideObj.type === 'html' ? 'under' : plugin.options.gallery.captions;
                            $('<figcaption>', {
                                html : '<div>' + slide.caption + '</div>',
                                class: 'cph-lightbox_gallery-caption cph-lightbox_gallery-caption-' + captionType
                            }).appendTo(slideFigure);
                        }

                        slideObj.figure = slideFigure;

                        slides.push(slideObj);
                    }
                });

                if(slides.length) {
                    var sContainer = $('<div class="cph-lightbox_gallery swiper-container"/>');
                    var sWrapper = $('<div class="swiper-wrapper"/>');

                    $.each(slides, function(i, slideObj) {
                        $('<div/>', {
                            class: 'swiper-slide cph-lightbox_gallery-slide cph-lightbox_gallery-slide-' + slideObj.type,
                            html : slideObj.figure
                        }).appendTo(sWrapper);
                    });

                    sContainer.html(sWrapper);

                    plugin.$inner = sContainer;
                    plugin._showModalInner();

                    var resizeImageSlides = function(slide) {
                        var maxHeight = plugin.$innerWrap.data('max-height');
                        var slides = slide ? [slide] : plugin.$innerWrap.find('.swiper-slide');
                        var maxCaptionHeight = maxHeight / 3;

                        maxCaptionHeight = parseInt(maxCaptionHeight);

                        $.each(slides, function() {
                            var slide = $(this),
                                inner = slide.find('.cph-lightbox_gallery-slide-inner'),
                                img = slide.find('.cph-lightbox_gallery-image'),
                                caption = slide.find('.cph-lightbox_gallery-caption'),
                                captionHeight, innerHeight, innerWidth;

                            inner.add(img).add(caption).css({maxHeight: '', maxWidth: ''});

                            innerWidth = parseInt(inner.width());
                            caption.css('max-width', innerWidth);

                            if(caption.is('.cph-lightbox_gallery-caption-within')) {

                                inner.add(img).css('max-height', maxHeight);

                                maxCaptionHeight = inner.height() / 4;

                                caption.css('max-height', parseInt(maxCaptionHeight));

                            } else {

                                captionHeight = parseInt(caption.height() || 0);
                                innerHeight = maxHeight - captionHeight;

                                if(captionHeight > maxCaptionHeight)
                                    innerHeight = maxHeight - maxCaptionHeight;

                                inner.add(img).css('max-height', innerHeight);
                                innerWidth = parseInt(inner.width());
                                caption.css('max-width', innerWidth);

                                captionHeight = maxHeight - inner.height();
                                caption.css('max-height', parseInt(captionHeight));

                            }
                        });
                    };

                    var swiperLazy = false;
                    if(plugin.options.gallery.lazyload) {
                        swiperLazy = {
                            loadPrevNext: true
                        };
                    }

                    var swiperConfig = {
                        loop          : true,
                        preloadImages : !swiperLazy,
                        lazy          : swiperLazy,
                        observer      : true,
                        autoHeight    : true,
                        centeredSlides: true,
                        grabCursor    : true,
                        initialSlide  : plugin.options.gallery.startIndex || 0,
                        pagination    : {
                            el  : '.cph-lightbox_misc',
                            type: 'fraction'
                        },
                        navigation    : {
                            nextEl: '.cph-lightbox_next',
                            prevEl: '.cph-lightbox_prev'
                        },
                        on            : {
                            afterInit     : function(swiper) {
                                plugin.$innerWrap.off('cphGalleryMaxHeight');
                                plugin.$innerWrap.on('cphGalleryMaxHeight', function() {
                                    resizeImageSlides();
                                    swiper.update();
                                });

                                resizeImageSlides();
                                swiper.update();
                            },
                            imagesReady   : function(swiper) {
                                resizeImageSlides();
                                swiper.update();
                            },
                            lazyImageReady: function(swiper, slide) {
                                resizeImageSlides(slide);
                                swiper.update();
                            },
                            slideChange   : function() {
                                plugin._doCallback(plugin.options.gallery.onSlideChange);
                            }
                        }
                    };

                    swiperConfig = $.extend(true, {}, plugin.options.gallery.swiper, swiperConfig);

                    new Swiper('.swiper-container', swiperConfig);
                }
            }
        },

        _showIframe: function() {
            var plugin = this;

            var iframe = $('<iframe/>', {
                src            : this.options.iframe.src,
                frameBorder    : '0',
                seamless       : 'seamless',
                allowfullscreen: ''
            }).hide();

            this.$fx.html(iframe).appendTo(this.$modal);

            iframe.one('load', function() {
                $(this).detach().appendTo(plugin.$inner).show();
                plugin._showModalInner();
            });
        },

        _showAjax: function() {
            var plugin = this;

            var ajax = $.ajax(this.options.ajax);

            var ajaxFailHandler = function(plugin) {
                plugin.destroy();
                plugin.$element.cphAlert('Request Failed', null, {titleClass: 'alert'});
            };

            var ajaxDataHandler = function(plugin, data) {
                if(typeof data === 'object') {
                    if(typeof data.html !== 'undefined') {
                        if(plugin.options.title === true && (typeof data.title !== 'undefined'))
                            plugin.options.title = data.title;

                        plugin.$innerPad.html(data.html).appendTo(plugin.$inner);
                        if(plugin.options.padded) plugin.$inner.addClass('cph-lightbox_inner-padded');
                        plugin._showModalInner();
                        return; // return out if created by object, otherwise continue.
                    }
                }

                var dHtml = $(data), dTitle = dHtml.filter('title').text();
                if(plugin.options.content && plugin.options.content !== 'html' && plugin.options.content !== 'body')
                    dHtml = dHtml.filter(plugin.options.content).html();

                if(dHtml) {
                    if(plugin.options.title === true && dTitle)
                        plugin.options.title = dTitle;

                    plugin.$innerPad.html(dHtml).appendTo(plugin.$inner);
                    if(plugin.options.padded) plugin.$inner.addClass('cph-lightbox_inner-padded');
                    plugin._showModalInner();
                    return; // return out if created by object, otherwise continue.
                }

                ajaxFailHandler(plugin);
            };

            ajax.done(function(data) {
                ajaxDataHandler(plugin, data);
            });

            ajax.fail(function() {
                ajaxFailHandler(plugin);
            });
        },

        _showDialog: function() {
            var plugin = this;
            this._addInnerContent();
            if(this.options.padded) this.$inner.addClass('cph-lightbox_inner-padded');

            if(this.options.dialog.buttons.length) {
                var buttons = $('<div/>', {class: 'cph-lightbox_buttons'});
                $.each(this.options.dialog.buttons, function(i, v) {
                    var button = $('<span/>', {
                        role    : 'button',
                        tabindex: '0',
                        class   : 'cph-lightbox_button',
                        html    : v.html
                    }).on(plugin.options.clickEvent, function() {
                        if(typeof v.onClick === 'function') {
                            v.onClick.call(this);
                            v.closeAfter = (typeof v.closeAfter !== 'undefined' && (v.closeAfter || v.closeAfter === 0)) ? v.closeAfter : false;
                            if(v.closeAfter !== false) {
                                setTimeout(function() {
                                    plugin.destroy();
                                }, v.closeAfter);
                            }
                        } else {
                            plugin.destroy();
                        }
                    }).on('keypress', function(e) {
                        if(e.keyCode === 13) {
                            $(this).trigger(plugin.options.clickEvent);
                        }
                    });

                    var addClass = function(className) {
                        if(typeof v.class === 'string' && v.class) {
                            v.class += ' ' + className;
                        } else {
                            v.class = className;
                        }
                    };

                    var addStyle = function(css) {
                        if(typeof v.style === 'string' && v.style) {
                            v.style += '; ' + css;
                        } else {
                            v.style = css + ';';
                        }
                        v.style = v.style.replace(/;+/, ';');
                    };

                    if(plugin.options.dialog.buttonClass) {
                        addClass(plugin.options.dialog.buttonClass);
                    }

                    if(plugin.options.dialog.buttonCss) {
                        addStyle(plugin.options.dialog.buttonCss);
                    }

                    if(typeof v.attrs !== 'undefined' && !$.isEmptyObject(v.attrs)) {
                        $.each(v.attrs, function(name, value) {
                            if(name === 'class') {
                                addClass(value);
                            } else if(name === 'style') {
                                addStyle(value);
                            } else {
                                button.attr(name, value);
                            }
                        });
                    }

                    if(typeof v.class === 'string' && v.class) {
                        $.each(v.class.split(' '), function(i, cls) {
                            if(Object.keys($.fn.cphLightbox.defaultColors.elements).indexOf(cls) !== -1) {
                                button.addClass('cph-lightbox_button-' + cls);
                            } else {
                                button.addClass(cls);
                            }
                        });
                    }

                    if(typeof v.style === 'string' && v.style) {
                        button.attr('style', v.style);
                    }

                    buttons.append(button);
                });
                this.$inner.append(buttons);
            }

            this._showModalInner();
        },

        _closeLightbox: function() {
            this.destroy();
            if(supportsHashChange && this.options.hash) {
                var hash = window.location.hash.substr(1);
                if(hash && hash === this.options.hash) {
                    if('referrer' in document) {
                        if(document.referrer === '' || document.referrer.indexOf(window.location.host) !== -1) {
                            window.history.back();
                        }
                    }
                }
            }
        }
    });

    $.fn.cphLightbox = function(options, callback) {
        this.each(function() {
            if(!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options, callback));
            }
        });
        return this;
    };

    $.fn.cphDialog = function(options, callback) {
        var opts = $.extend(true, {}, $.fn.cphDialog.defaults, options);
        return $(this).cphLightbox(opts, callback);
    };

    $.fn.cphAlert = function(alertHtml, okButton, options) {
        if(!okButton) okButton = cphLightbox.button('OK', null, null);
        else if(typeof okButton === 'function') okButton = cphLightbox.button('OK', null, okButton);
        else if(typeof okButton === 'string') okButton = cphLightbox.button(okButton, null, null);

        var opts = $.extend(true, {}, {
            title  : 'Alert!',
            content: alertHtml,
            dialog : {
                buttons: [okButton]
            }
        }, options);

        return $(this).cphDialog(opts);
    };

    $.fn.cphConfirm = function(confirmHtml, doYes, doNo, options) {
        if(!doYes) doYes = cphLightbox.button('Yes, proceed', null, null);
        else if(typeof doYes === 'function') doYes = cphLightbox.button('Yes, proceed', null, doYes);
        else if(typeof doYes === 'string') doYes = cphLightbox.button(doYes, null, null);

        if(!doNo) doNo = cphLightbox.button('Cancel', null, null);
        else if(typeof doNo === 'function') doNo = cphLightbox.button('Cancel', null, doNo);
        else if(typeof doNo === 'string') doNo = cphLightbox.button(doNo, null, null);

        var opts = $.extend(true, {}, {
            title  : 'Are You Sure?',
            content: confirmHtml,
            dialog : {
                buttons: [doYes, doNo]
            }
        }, options);

        return $(this).cphDialog(opts);
    };

    /**
     * If needing to call any of these without stringing an element
     */
    $.cphLightbox = function(options, callback) {
        return $('<div/>').cphLightbox(options, callback);
    };

    $.cphDialog = function(options, callback) {
        return $('<div/>').cphDialog(options, callback);
    };

    $.cphAlert = function(alertHtml, button, options) {
        return $('<div/>').cphAlert(alertHtml, button, options);
    };

    $.cphConfirm = function(confirmHtml, doYes, doNo, options) {
        return $('<div/>').cphConfirm(confirmHtml, doYes, doNo, options);
    };

    /**
     * Build a button for the $.cphDialog() type
     *
     * @param html              string          the text / innerHTML of the button
     * @param classOrAttributes object|string   object of attribute:value pairs, otherwise className
     * @param onClick           function|null   onClick callback. Closes dialog if left empty
     * @param closeAfter        int|false       time to wait before closing dialog after button click. false == don't close
     *
     * @returns {{onClick: *, closeAfter: (*|number), html: *, class: (*|null), attrs: (null|object)}}
     */
    cphLightbox.button = function(html, classOrAttributes, onClick, closeAfter) {
        var attrs = (typeof classOrAttributes === 'object') ? classOrAttributes : null,
            cls = attrs ? null : classOrAttributes;
        return {
            html      : html, // the text / innerHTML of the button
            class     : cls, // class applied to the button
            attrs     : attrs, // additional attributes to add to button
            onClick   : onClick, // onClick callback. Closes dialog if left empty
            closeAfter: (closeAfter || closeAfter === false) ? closeAfter : 0 // time to wait before dialog closes after buttons clicked. false == don't close
        };
    };

    cphLightbox.imageSlide = function(src, caption, alt, srcset, sizes, onShow, onHide) {
        return {
            src    : src, // required
            srcset : srcset, // optional
            sizes  : sizes, // optional
            alt    : alt, // optional
            caption: caption, // optional
            onShow : onShow, // callback when slide is visible
            onHide : onHide // callback when slide is hidden
        };
    };

    cphLightbox.htmlSlide = function(contentOrSelector, caption, onShow, onHide) {
        return {
            content: contentOrSelector, // required
            caption: caption, // optional
            onShow : onShow, // callback when slide is visible
            onHide : onHide // callback when slide is hidden
        };
    };

    cphLightbox.addElementColorClass = function(className, bgColor, txtColor, mixPct) {
        $.fn.cphLightbox.defaultColors.elements[className] = [bgColor, txtColor, mixPct];
    };

    cphLightbox.get = function(el) {
        if($(el).is('.cph-lightbox'))
            return $(el);

        return $(el).closest('.cph-lightbox');
    };

    cphLightbox.hide = function(el) {
        cphLightbox.get(el).trigger('close');
    };

    cphLightbox.getZIndex = function(el) {
        return parseInt(cphLightbox.get(el).css('zIndex'));
    };

    cphLightbox.hideAll = function() {
        var closeTimeout = 0,
            closeAfter = 0;

        $('.cph-lightbox').each(function() {
            var box = $(this);

            closeTimeout = closeTimeout + closeAfter + 50;
            closeAfter = box.data('transition-time');

            setTimeout(function() {
                box.trigger('close');
            }, closeTimeout);
        });

        setTimeout(function() {
            setActiveModal();
        }, closeTimeout + closeAfter + 50);
    };

    /**
     * To change globally, $.fn.cphLightbox.defaults.transitionTime = 90;
     */
    $.fn.cphDialog.defaults = {
        type               : 'dialog',
        breakpoint         : 0,
        transitionTime     : 180,
        height             : 'auto',
        width              : 'auto',
        hash               : null,
        showClose          : null,
        closeOnEscape      : null,
        closeOnClickOutside: null,
        dialog             : {
            buttons: [
                {
                    html   : 'OK', // DISPLAY NAME
                    class  : null, // BUTTON CLASS
                    onClick: null // ONCLICK CALLBACK
                }
            ]
        }
    };

    /**
     * Colors to use for the lightbox. Can only be set globally as
     * $.fn.cphLightbox.defaultColors.dark = '#000000';
     *
     * defaultColors.elements colors can be used to update background colors of title bars, buttons, etc.
     * they are entered as a follows: cphLightbox.addElementColorClass('className', 'bgHexColor', 'textHexColor', lightenDarken);
     *
     * cphLightbox.addElementColorClass('success', '#006400', '#FFFFFF', 18);
     * cphLightbox.addElementColorClass('warning', '#FF8C00', '#FFFFFF', 18);
     * cphLightbox.addElementColorClass('alert', '#8B0000', '#FFFFFF', 18);
     * cphLightbox.addElementColorClass('info', '#009BFF', '#FFFFFF', 18);
     */
    $.fn.cphLightbox.defaultColors = {
        dark    : '#0D0D0D',
        light   : '#FFFFFF',
        accent  : '#333333',
        elements: {
            alert: ['#8B0000', '#FFFFFF', 15]
        }
    };

    /**
     * To change globally $.fn.cphLightbox.defaults.breakpoint = 1024;
     */
    $.fn.cphLightbox.defaults = {
        type               : 'inline', // inline, image, iframe, ajax, dialog, gallery
        breakpoint         : 768, // at what pixel width does it change from mobile to desktop
        transitionTime     : 300, // time it takes for modal inner windows to open & close
        clickEvent         : 'click', // event which triggers all clicks within modal
        height             : null, // max-height
        width              : null, // max-width
        ratio              : null, // if height or width set, the ratio to maintain
        padded             : true, // whether to add inner padding to inline, ajax or dialog
        zIndex             : null, // starting z-index if default does not work
        outerClass         : null, // added to .cph-lightbox, which is the outermost element
        innerClass         : null, // added to .cph-lightbox_inner, which is the content container
        showClose          : true, // whether or not to show the close button
        closeOnEscape      : true, // whether to close focused modal on escape key
        closeOnClickOutside: true, // whether to close focused modal if clicked outside
        closeOn            : null, // jQuery selector for element which closes modal on 'clickEvent'
        confirm            : null, // confirm dialog text to prompt before opening lightbox
        hash               : null, // include hash to allow modal to be tracked by hashchange event
        title              : null, // true to get title from returned HTML, otherwise string
        titleClass         : null, // added to .cph-lightbox_title, which is the outermost title element
        titleCss           : null, // style to add to .cph-lightbox_title element
        content            : null, // HTML content or jQuery selector or jQuery object to get innerHTML from
        image              : {
            src   : null, // img src attribute
            srcset: null, // img srcset attribute
            sizes : null // img sizes attribute
        },
        iframe             : {
            src: null // iframe src attribute
        },
        ajax               : {     // any jQuery.ajax({}) properties, including success, complete or error callbacks.
            async   : true,
            cache   : false,
            method  : 'get',       // if response is JSON object, should have field 'html' & 'title' if wanted. Otherwise entire data will be response.
            url     : null,
            success : $.noop(),
            error   : $.noop(),
            complete: $.noop()
        },
        gallery            : {
            slides       : [],     // array of image src url's or array of objects { src : 'imgSrc', caption : 'captionHtml', [srcset : 'srcset'], [sizes : 'sizes'] }
            slideClass   : null, // class to add to the outer element of each slide
            slideCss     : null, // css to add to the outer element of each slide
            lazyload     : true,   // whether to lazyload subsequent images
            selector     : null,   // jQuery selector that each <img> or <figure> will have. Will look first for 'figure>img & figure>figcaption', then 'img && img[title]'
            captions     : 'under', // position of captions in relation to the image ('under', 'within', false)
            startIndex   : 0, // Zero-based index of slide to show first
            onSlideChange: $.noop(), // callback function triggered each time a slide change happens
            swiper       : {} // because we use Swiper JS as our gallery, any config overrides go here
        },
        dialog             : {
            buttons    : [],   // array of buttons for 'dialog' types
            buttonClass: null, // class to add to all buttons
            buttonCss  : null // styles to add to all buttons
        },
        onInit             : null, // IMMEDIATELY ON PLUGIN START
        onBeforeOpen       : null, // IMMEDIATELY BEFORE SET SCREEN SIZE CALLED
        onOpen             : null, // IMMEDIATELY AFTER MODAL VISIBLE
        onBeforeClose      : null, // IMMEDIATELY BEFORE DESTRUCT
        onClose            : null  // IMMEDIATELY AFTER DESTRUCT
    };

    $(document).on('click', '[data-lightbox]', function(e) {
        e.preventDefault();

        var clicked = $(this),
            data = clicked.data('lightbox'),
            options = {};

        if(clicked.is('img')) {
            options = {
                type : 'image',
                image: {
                    src   : clicked.attr('src'),
                    srcset: clicked.attr('srcset'),
                    sizes : clicked.attr('sizes')
                }
            };
        } else if(clicked.is('a')) {
            options = {
                type: 'ajax',
                ajax: {
                    url: $(this).attr('href')
                }
            };
        }

        options = $.extend(true, {}, options, data);
        clicked.cphLightbox(options);
    });
})(jQuery, window, document);